<template>
    <div>
        <div class="page-wrapper">
            <div class="page-content">
                <TopBar :tracking="tracking"></TopBar>
                <dashboard-slider :apiConfig="dashboardConfig"
                    :tracking="tracking"
                    :trackingCate="'banner'"
                    :trackingAction="'click_banner'"
                    :trackingEvent="'home'"
                ></dashboard-slider>
                <div>
                    <HomeMenu></HomeMenu>
                </div>
            </div>
        </div>
        <FooterMenu
            currentMenu="home"
            :controller="modalController">
        </FooterMenu>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import Vue from "vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
// component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import FooterMenu from "@/components/Layout/FooterMenu/FooterMenu.vue";
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
import HomeMenu from "../component/HomeMenu.vue";
// core
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "Home",
    mixins: [LocaleMixin, ModalMixin, AccountMixin],
    components: {
        TopBar,
        DashboardSlider,
        FooterMenu,
        HomeMenu,
    },
    data: function() {
        return {
            isLoading: false,

            dashboardConfig: ConfigManager.getDashboardConfig().mainDashboard,
            busModal: new Vue(),

            tracking: new TrackingService(this)
        };
    },
    created: function() {
        this.tracking.screenName('Home_Page');
    },
    methods: {
        //utilities
        showLoading: function() {
            setTimeout(() => {
                this.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
        onClickShowAll: function() {
            this.tracking.event('all_reward', 'click_all_reward');
            this.$router.push('/rewards');
        },
    }
};
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "../style/Home.scss";

</style>
